<template>
  <v-snackbar
    top
    right
    v-model="internalSnackbar"
    :color="snackColor"
    multi-line
    :timeout="5000">
    {{ msg }}
  </v-snackbar>
</template>

<script>
import SessionTools from '@/mixins/sessionTools';

export default {
  name: 'snackbar',
  mixins: [SessionTools],
  data() {
    return {
      internalSnackbar: false,
      snackColor: null,
      msg: '',
    };
  },
  watch: {
    snackbar({ type, msg }) {
      this.snackColor = type === 'ERROR' ? 'error' : 'info';
      this.msg = msg;
      this.internalSnackbar = true;
    },
  },
};
</script>
